import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { DASHBOARD_PRICE_FILTER_WEEK, DASHBOARD_PRICE_FILTER_YEAR } from './definitions';
import { PriceFilter, PriceStore } from '../../../analysis/stores/price.store';
import { SwitchBar, SwitchBarOption } from 'excellence-ui';
import { AnalysisPriceGraphChart } from '../../../analysis/components/analysis-price-graph-chart/analysis-price-graph-chart';
import { form, FormField } from '@angular/forms/signals';
import { DatePipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard-hpfc-price-card',
  templateUrl: './dashboard-hpfc-price-card.html',
  imports: [
    SwitchBar,
    SwitchBarOption,
    AnalysisPriceGraphChart,
    FormField,
    DatePipe,
    TranslocoPipe,
  ],
})
export class DashboardHpfcPriceCard implements OnInit {
  private priceStore = inject(PriceStore);

  protected filter = signal<PriceFilter>(DASHBOARD_PRICE_FILTER_YEAR);
  protected form = form(this.filter);

  protected data = computed(() => this.priceStore.get(this.filter()));

  ngOnInit(): void {
    if (!this.priceStore.get(DASHBOARD_PRICE_FILTER_YEAR)) {
      this.priceStore.load(DASHBOARD_PRICE_FILTER_YEAR);
    }
    if (!this.priceStore.get(DASHBOARD_PRICE_FILTER_WEEK)) {
      this.priceStore.load(DASHBOARD_PRICE_FILTER_WEEK);
    }
  }

  protected onClickReload() {
    this.priceStore.load(this.filter());
  }
}
